// src/modules/auth/constants.ts

export const NEW_CODE_TIMEOUT = 10;
export const SINGLE_DIGIT_REGEX = /^\d$/;
export const CODE_LENGTH = 6;
